import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Center, Text } from '@bonusly/design-system';

export const NoActivityEmptyState: FC = () => {
	const { t } = useTranslation('rewards');

	return (
		<Center p={6} borderWidth="1px" borderColor="border.subtle" borderRadius="md" bg="bg.subtle">
			<Text color="text.softer" fontSize="sm">
				{t('highlights.noActivity')}
			</Text>
		</Center>
	);
};
